import React, { forwardRef, useEffect, useImperativeHandle, useState } from 'react'
import { Button, Form, Input, Space } from 'antd'
import { WysiwygEditor } from '../Editor/WysiwygEditor'
import { Page } from '../../services/models'

export type PageFormFields = {
  title: string;
  url: string;
  content: string;
}

export type Props = {
  data?: Page;
  onSubmit: (data: PageFormFields) => void;
  showActions?: boolean;
}

export type PageFormHandle = {
  submit: () => void;
}

export const PageForm = forwardRef<PageFormHandle, Props>(({ data, onSubmit, showActions = true }, ref) => {
  const [isEdit, setIsEdit] = useState(!!data)
  const [form] = Form.useForm()

  useImperativeHandle(ref, () => ({
    submit: () => form.submit()
  }), [form])

  useEffect(() => {
    setIsEdit(!!data)
  }, [data])

  useEffect(() => {
    if (isEdit) {
      form.setFieldsValue({
        title: data?.title,
        url: data?.url,
        content: data?.content
      })
    }
  }, [isEdit])

  return (
    <Form
      form={form}
      layout="vertical"
      hideRequiredMark
      style={{ width: '100%' }}
      onFinish={onSubmit}
    >
      <Form.Item
        label="Заголовок"
        name="title"
        rules={[
          {
            required: true,
            message: 'Пожалуйста заполните заголовок'
          }
        ]}
      >
        <Input/>
      </Form.Item>
      <Form.Item
        label="URL"
        name="url"
        rules={[
          {
            required: true,
            message: 'Пожалуйста заполните URL'
          }
        ]}
      >
        <Input placeholder={'например: about'}/>
      </Form.Item>
      <Form.Item
        label="Содержание"
        name="content"
      >
        {/* @ts-ignore */}
        <WysiwygEditor placeholder={'Содержание страницы'}/>
      </Form.Item>
      <Space>
        {showActions && (
          <Button
            type="primary"
            onClick={form.submit}
          >
            Сохранить
          </Button>
        )}
      </Space>
    </Form>
  )
})

PageForm.displayName = 'PageForm'
